import './style/index.less';
import RecaptchaDialog from './RecaptchaDialog';

export default RecaptchaDialog;
